export const QuizDifficultyType = Object.freeze({
Easy: 1,
Normal: 2,
Hard: 3,
});
